module.exports = __webpack_public_path__ + "static/Pc-fcb0800434a9a2f26baf3ad012210173.svg";